import { useSelector } from 'react-redux';

export const useFinancialIndicatorsBlockInfo = () => {
    //@ts-ignore
    const { is_customer } = useSelector((state) => state.dashboardReducer);
    return { is_customer };
};
